<template>
    <div class="overflow-x-auto">
        <table class="min-w-full divide-y divide-gray-100">
            <thead class="bg-gray-50">
                <tr>
                    <SortableTh :label="t('vue.id')" field="id" />
                    <SortableTh :label="t('vue.team')" field="team_name" />
                    <SortableTh
                        :label="t('vue.kiosk_da_owner_email')"
                        field="owner_email"
                    />
                    <SortableTh
                        :label="t('vue.kiosk_da_service')"
                        field="service"
                    />
                    <SortableTh
                        :label="t('vue.kiosk_da_periodicity')"
                        field="periodicity"
                    />
                    <SortableTh
                        :label="t('vue.kiosk_da_subscription_start')"
                        field="subscription_start_at"
                    />
                    <SortableTh
                        :label="t('vue.kiosk_da_subscription_end')"
                        field="subscription_end_at"
                    />
                    <SortableTh
                        :label="t('vue.kiosk_da_paid_slots')"
                        field="paid_slots"
                        align="center"
                    />
                    <SortableTh
                        :label="t('vue.kiosk_da_used_domains')"
                        field="used_domains"
                        align="center"
                    />
                    <th
                        class="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-gray-500"
                    />
                </tr>
            </thead>
            <tbody class="divide-y divide-gray-100">
                <tr
                    v-for="item in items"
                    :key="item.id"
                    class="hover:bg-gray-50/60"
                >
                    <td class="px-4 py-3 font-mono text-xs text-gray-400">
                        {{ item.id }}
                    </td>
                    <td class="px-4 py-3 text-sm font-medium text-gray-900">
                        <div class="flex items-center gap-2">
                            <div
                                class="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-teal-100"
                            >
                                <CalendarIcon
                                    class="h-3.5 w-3.5 text-teal-600"
                                />
                            </div>
                            {{ item.team_name }}
                        </div>
                    </td>
                    <td class="px-4 py-3 text-sm text-gray-600">
                        {{ item.owner_email ?? "—" }}
                    </td>
                    <td class="px-4 py-3 text-sm text-gray-600">
                        <span
                            class="inline-flex items-center gap-1 rounded-full bg-teal-50 px-2 py-0.5 text-xs font-medium text-teal-700"
                        >
                            <CurrencyDollarIcon class="h-3 w-3" />
                            {{ item.service }}
                        </span>
                    </td>
                    <td class="px-4 py-3 text-sm text-gray-600">
                        <span
                            class="inline-flex items-center gap-1 rounded-full bg-indigo-50 px-2 py-0.5 text-xs font-medium text-indigo-700"
                        >
                            <CalendarDaysIcon class="h-3 w-3" />
                            {{ item.periodicity }}
                        </span>
                    </td>
                    <td class="px-4 py-3 text-sm text-gray-600">
                        {{ item.subscription_start_at ?? "—" }}
                    </td>
                    <td class="px-4 py-3 text-sm text-gray-600">
                        {{ item.subscription_end_at ?? "—" }}
                    </td>
                    <td
                        class="px-4 py-3 text-center text-sm font-medium text-gray-600"
                    >
                        {{ item.paid_slots }}
                    </td>
                    <td
                        class="px-4 py-3 text-center text-sm font-medium text-gray-600"
                    >
                        {{ item.used_domains }}
                    </td>
                    <td class="px-4 py-3 text-right text-sm text-gray-600">
                        <AdminLink :href="item.kiosk_url" />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script lang="ts" setup>
import {
    CalendarIcon,
    CalendarDaysIcon,
    CurrencyDollarIcon,
} from "@heroicons/vue/24/outline";
import { useTranslations } from "@/composables/useTranslations";
import type { IYearlySubItem } from "../../types";

const { t } = useTranslations();

defineProps<{
    items: IYearlySubItem[];
}>();
</script>
